var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"width":"1","height":"1","scrolling":"no","src":`https://springmedia.go2cloud.org/aff_l?offer_id=3876&adv_sub=${_vm.uuid}&amount=${_vm.amountBR}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }